import { totalRecordDetailConstants } from "../constant/totalRecordDetail.constants";

export const initialState = {
    dataTotal: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false,
};
const totalRecordDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case totalRecordDetailConstants.GET_SUCCESS:
            return {
                ...state,
                errorCode: action.totalRecordDetailList.error_code,
                dataTotal: action.totalRecordDetailList.result,
                isLoading: false
            };    

        case totalRecordDetailConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };   

        case totalRecordDetailConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };      

        default:
            return state;
    }
};

export default totalRecordDetailReducer;
